import { useState } from "react"

export const RealPropertyState = () => {
   
    const [templateForm, setTemplateForm] = useState({
        method: '',
        status: '',
        id: '',
        template_id: '',
        device_type: '',
        submit: { modal: false, type: 0, status: 0, confirmed: false },
        own_domain: { value: '', stat: false, msg: '' },
        website_link: { value: '', stat: false, msg: '' },
        properties: {
            list:"",
            top: {
                buttons: {
                    bg: "", color: "",
                    logIn: "", logOut: "", signIn: "" 
                },
                title: { value: "", fontsize: "" },
                bg_color: "",
            },
            site_btns: { bg: "", color: "" }
        },
        logo: "",

    })
    const [themeBtn, setThemeBtn] = useState({ theme: false, themeOption: false, site: { colors: false, identity: false } })
    const [showPicker, setShowPicker] = useState({ buttons: { bg: false, colors: false, palletPicker: false }, header: { bg: false, btn: { bg: false, color: false }, title_color: false } });
    const [showSidebar, setShowSidebar] = useState(false);
    const [sideBarContent, setSideBarContent] = useState({site_identity: false, site_color: false  })
    const [tLoader, setTLoader] = useState(true);
    const [prevLoader, setPrevLoader] = useState(true)
    const [activeTab, setActiveTab] = useState({url: "list", offerType: "rent"});
    const [preview, setPreview] = useState({
        status: '',
        id: '',
        template_id: '',
        device_type: '',
        submit: { modal: false, type: 0, status: 0, typeModal: '', confirmed: false },
        own_domain: { value: '', stat: false, msg: '' },
        website_link: { value: '', stat: false, msg: '' },
        properties: {
            list: [],
            top: {
                buttons: {
                    bg: "", color: "",
                    logIn: "", logOut: "", signIn: "" 
                },
                title: { value: "", fontsize: "" },
                bg_color: "",
            },
            site_btns: { bg: "", color: "" }
        },
        logo: "",
    });
    const [subTypes, setSubTypes] = useState({
        value: [],
        loader: false,
    })
    const [provinceData, setProvinceData] = useState({
        value: [],
        loader: false,
    })
    const [slctdSubType, setSlctdSubType] = useState(0)
    const [slctdLocation, setSlctdLocation] = useState(0)
    const [loader, setLoader] = useState(true); // back to true
    const [inftScroll, setinftScroll] = useState(true);
    const [lastId, setLastId] = useState();
    const [cooldown, setCooldown] = useState(false);
    const [hasMore, setHasMore] = useState(true); 
    const [isLoading, setIsLoading] = useState(false);
    const [view, setView] = useState({
        details: "",
        attachments: "",
    })
    const [viewLoader, setViewLoader] = useState(false);
    const [avlblePrprtyTypes, setAvlblePrprtyTypes] = useState({
        value: [],
        loader: false,
    })
	const [types, setTypes] = useState({
        propertyTypes: [],
        propertySubTypes: [],
        allPropertySubTypes: [],
        indoorFacilities: [],
        outdoorFacilities: [],
        checkListItems: [],
    })

    return {
        //website in campaign part
        themeBtn: { data: themeBtn, set: setThemeBtn },
        templateForm: { data: templateForm, set: setTemplateForm },
        showPicker: { data: showPicker, set: setShowPicker },
        showSidebar: { data: showSidebar, set: setShowSidebar },
        sideBarContent: { data: sideBarContent, set: setSideBarContent },
        tLoader: { data: tLoader, set: setTLoader },
        preview: { data: preview, set: setPreview },
        prevLoader: { data: prevLoader, set: setPrevLoader },
        activeTab: { data: activeTab, set: setActiveTab },
        subTypes: { data: subTypes, set: setSubTypes },
        provinceData: { data: provinceData, set: setProvinceData },
        slctdSubType: { data: slctdSubType, set: setSlctdSubType },
        slctdLocation: { data: slctdLocation, set: setSlctdLocation },
        loader: { data: loader, set: setLoader },
        inftScroll: { data: inftScroll, set: setinftScroll },
        lastId: { data: lastId, set: setLastId },
        view: { data: view, set: setView },
        viewLoader: { data: viewLoader, set: setViewLoader },
        cooldown: { data: cooldown, set: setCooldown },
        hasMore: { data: hasMore, set: setHasMore },
        isLoading: { data: isLoading, set: setIsLoading },
        avlblePrprtyTypes: { data: avlblePrprtyTypes, set: setAvlblePrprtyTypes},
		types: { data: types, set: setTypes },
    }
}